module.exports = __webpack_public_path__ + "img/chart.9ecfa289.svg";